const MasterLoader = () => {
  return (
    <svg
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="animate-spin"
    >
      <path
        d="M53.5 28C53.5 31.283 52.8534 34.5339 51.597 37.5671C50.3406 40.6002 48.4991 43.3562 46.1777 45.6777C43.8562 47.9991 41.1002 49.8406 38.0671 51.097C35.0339 52.3534 31.783 53 28.5 53C25.2169 53 21.966 52.3534 18.9329 51.097C15.8998 49.8406 13.1438 47.9991 10.8223 45.6777C8.50086 43.3562 6.65938 40.6002 5.40301 37.5671C4.14664 34.5339 3.5 31.283 3.5 28C3.5 24.7169 4.14665 21.466 5.40302 18.4329C6.65938 15.3998 8.50087 12.6438 10.8223 10.3223C13.1438 8.00086 15.8998 6.15937 18.9329 4.90301C21.9661 3.64664 25.217 3 28.5 3C31.7831 3 35.034 3.64665 38.0671 4.90302C41.1002 6.15939 43.8562 8.00087 46.1777 10.3223C48.4991 12.6438 50.3406 15.3998 51.597 18.4329C52.8534 21.4661 53.5 24.717 53.5 28L53.5 28Z"
        stroke="#F5F5F5"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.5 3C31.783 3 35.0339 3.64664 38.0671 4.90301C41.1002 6.15938 43.8562 8.00087 46.1777 10.3223C48.4991 12.6438 50.3406 15.3998 51.597 18.4329C52.8534 21.4661 53.5 24.717 53.5 28"
        className="stroke-primary"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MasterLoader;
